import { IWebsites } from '../interfaces/analyticsInterfaces'
import { trackGACustomEvent, trackDatadogAction } from '../common'
import { GA_TRACK_CATEGORY } from '../constants'

const EVENT_SUGGESTED_PASSCODE_ACCEPT = 'suggested_passcode_acepted'
const EVENT_SUGGESTED_PASSCODE_REJECT = 'suggested_passcode_rejected'

export const Websites: IWebsites = {
  trackSuggestedPasscode: (isAcepted: boolean) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.WEBSITE,
      action: isAcepted ? EVENT_SUGGESTED_PASSCODE_ACCEPT : EVENT_SUGGESTED_PASSCODE_REJECT,
    })
    trackDatadogAction({
      name: GA_TRACK_CATEGORY.SECRET,
      item: 'suggested_passcode',
      value: isAcepted ? EVENT_SUGGESTED_PASSCODE_ACCEPT : EVENT_SUGGESTED_PASSCODE_REJECT,
    })
  },
}
